export const GOOGLE_ONE_TAP_PARENT_CONTAINER_ID = 'google_one_tap_container';
export const GOOGLE_AUTH_SDK = 'https://accounts.google.com/gsi/client';
export const GOOGLE_ONE_TAP_CLOSE_SKIP_REASON = 'user_cancel';
